import React from 'react'

const Passport = () => {
  return (
    <span className="passport-svg-wrapper">
      <svg viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.618164 25.2341C0.618164 11.4488 11.8921 0.233887 25.7504 0.233887L25.7496 0.234275C39.6071 0.234275 50.8814 11.4492 50.8814 25.2341C50.8814 39.019 39.6075 50.2339 25.75 50.2339C11.8921 50.2339 0.618164 39.019 0.618164 25.2341ZM20.8542 20.3645L25.6518 4.12217C14.0251 4.17464 4.57836 13.5719 4.52561 25.1377L20.8542 20.3645ZM4.52561 25.3297L20.8538 30.1025L25.6514 46.3448C14.0247 46.2927 4.57797 36.8951 4.52561 25.3297ZM25.8455 46.3444L30.6435 30.1021L46.9713 25.3297C46.9189 36.8947 37.4722 46.2927 25.8455 46.3444ZM46.9722 25.1373L46.9718 25.1372C46.9198 13.5714 37.4731 4.17425 25.8465 4.12217L30.644 20.3648L46.9718 25.1372V25.1373H46.9722Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3512 15.8026L18.6511 18.1733L16.2683 18.8697L12.5635 12.1176L19.3512 15.8026ZM38.9319 12.1182L35.2274 18.8704L32.8443 18.174L32.1442 15.8033L38.9319 12.1182ZM32.1451 34.6653L32.8452 32.2947L35.2284 31.5982L38.9328 38.3504L32.1451 34.6653ZM16.268 31.5982L12.5639 38.3504L19.3516 34.6653L18.6515 32.2947L16.268 31.5982Z"
          fill="white"
        />
      </svg>
    </span>
  )
}

export default Passport
